/* Home reviews (2026-10-17): Instagram-style posts, real Judge.me reviews.
   Reads Judge.me's public carousel feed (the one their own widget uses) once the section is near the screen and draws every
   review like an Instagram post (name, photo, icons, stars, the review text right under the photo, product tag) in a swipe row
   with arrows that also moves by itself. Tapping the photo or "more" opens a pop-up with the big photo and the full review.
   Everything is built with DOM APIs: customer text is only ever inserted as text, never as HTML. */
(function () {
  'use strict';
  var root = document.querySelector('[data-hv-reviews]');
  if (!root) return;
  var grid = root.querySelector('[data-grid]');
  var fail = root.querySelector('.hv-rev__fail');
  var data = [], started = false, modal = null, idx = 0, lastFocus = null;

  function decode(s) { try { return new DOMParser().parseFromString(String(s || ''), 'text/html').documentElement.textContent || ''; } catch (e) { return String(s || ''); } }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function setWidth(url, w) { return String(url).replace(/([?&]width=)\d+/, '$1' + w); }
  function shortName(t) { return decode(t).split('|')[0].trim(); }
  function clip(s, n) { s = String(s || '').replace(/\s+/g, ' ').trim(); return s.length > n ? s.slice(0, n).replace(/\s+\S*$/, '') + '\u2026' : s; }
  function stars(n, cls) { var f = el('span', cls || 'hv-ig__stars'); f.appendChild(el('span', '', '\u2605'.repeat(n))); if (n < 5) f.appendChild(el('span', 'hv-ig__off', '\u2605'.repeat(5 - n))); f.setAttribute('role', 'img'); f.setAttribute('aria-label', n + ' out of 5 stars'); return f; }
  function rate(r) { return Math.max(0, Math.min(5, Math.round(Number(r.rating) || 0))); }
  function photo(r) { var p = r.pictures_urls && r.pictures_urls[0]; return p ? (p.huge || p.original || p.small) : ''; }

  /* ---------- the pop-up ---------- */
  function ensureModal() {
    if (modal) return modal;
    var m = el('div', 'hv hv-igm'); m.hidden = true; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Customer review');
    var box = el('div', 'hv-igm__box');
    var close = el('button', 'hv-igm__x', '\u00D7'); close.type = 'button'; close.setAttribute('aria-label', 'Close');
    var fig = el('div', 'hv-igm__fig'); var img = document.createElement('img'); img.alt = ''; img.decoding = 'async'; fig.appendChild(img);
    var side = el('div', 'hv-igm__side');
    var who = el('div', 'hv-igm__who'); var lg = root.getAttribute('data-logo');
    if (lg) { var li = document.createElement('img'); li.className = 'hv-igm__logo'; li.src = lg; li.alt = ''; li.width = 36; li.height = 36; who.appendChild(li); }
    var nm = el('span', 'hv-igm__name'); nm.appendChild(el('b')); nm.appendChild(el('small')); who.appendChild(nm);
    var st = el('div', 'hv-igm__st'); var body = el('p', 'hv-igm__body'); var link = el('a', 'hv-igm__link', 'View this product \u2192');
    var nav = el('div', 'hv-igm__nav');
    var prev = el('button', 'hv-rf__btn'); prev.type = 'button'; prev.setAttribute('aria-label', 'Previous review'); prev.textContent = '\u2190';
    var cnt = el('span', 'hv-igm__cnt'); var next = el('button', 'hv-rf__btn'); next.type = 'button'; next.setAttribute('aria-label', 'Next review'); next.textContent = '\u2192';
    nav.appendChild(prev); nav.appendChild(cnt); nav.appendChild(next);
    side.appendChild(who); side.appendChild(st); side.appendChild(body); side.appendChild(link); side.appendChild(nav);
    box.appendChild(close); box.appendChild(fig); box.appendChild(side); m.appendChild(box); document.body.appendChild(m);
    close.addEventListener('click', closeModal);
    m.addEventListener('click', function (e) { if (e.target === m) closeModal(); });
    prev.addEventListener('click', function () { show(idx - 1); });
    next.addEventListener('click', function () { show(idx + 1); });
    document.addEventListener('keydown', function (e) {
      if (m.hidden) return;
      if (e.key === 'Escape') closeModal();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'Tab') { var f = m.querySelectorAll('button, a[href]'); if (!f.length) return; var a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); } }
    });
    modal = { m: m, img: img, name: nm.firstChild, sub: nm.lastChild, st: st, body: body, link: link, cnt: cnt, close: close };
    return modal;
  }
  function show(i) {
    var M = ensureModal(); idx = (i + data.length) % data.length; var r = data[idx];
    M.img.src = setWidth(photo(r), 900); M.img.alt = 'Photo from ' + (r.reviewer_name || 'a customer');
    M.name.textContent = r.reviewer_name || 'Customer';
    M.sub.textContent = '\u2713 Verified buyer' + (r.product_title ? ' \u00B7 ' + shortName(r.product_title) : '');
    M.st.textContent = ''; M.st.appendChild(stars(rate(r), 'hv-igm__stars'));
    M.body.textContent = String(r.body || r.title || '').replace(/\s+/g, ' ').trim();
    if (r.product_url) { M.link.href = r.product_url; M.link.hidden = false; } else { M.link.hidden = true; }
    M.cnt.textContent = (idx + 1) + ' / ' + data.length;
  }
  /* 2026-10-23 speed (INP): opening/closing must stay cheap on a slow phone. No class on <html> (that forces the whole long page
     to re-layout), the overlay itself scrolls and does not pass scrolling to the page (overscroll-behavior), the focus move
     happens after the first paint, and the pop-up DOM is built before the first tap (see build()). */
  function openModal(i) {
    var M = ensureModal(); lastFocus = document.activeElement; show(i); M.m.hidden = false;
    requestAnimationFrame(function () { setTimeout(function () { if (!M.m.hidden) M.close.focus({ preventScroll: true }); }, 0); });
  }
  function closeModal() {
    if (!modal) return; modal.m.hidden = true;
    var f = lastFocus; requestAnimationFrame(function () { if (f && f.focus) f.focus({ preventScroll: true }); });
  }

  /* ---------- the Instagram-style posts ---------- */
  var ICONS = {
    heart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 2.6 5 6 5c2 0 3.4 1.1 4 2.2h4C14.600 6.100 16 5 18 5c3.400 0 5.100 3.400 3.600 6.800C19.500 16.400 12 21 12 21z" fill="currentColor"/></svg>',
    chat: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 11.500a8.500 8.500 0 0 1-12.300 7.600L3 20.500l1.500-5.300A8.500 8.500 0 1 1 21 11.500z" fill="none" stroke="currentColor" stroke-width="1.800" stroke-linejoin="round"/></svg>',
    send: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M22 3 2 10.500l7.500 3L12.500 21 22 3zM9.500 13.500 22 3" fill="none" stroke="currentColor" stroke-width="1.800" stroke-linejoin="round" stroke-linecap="round"/></svg>',
    save: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h12v18l-6-4.500L6 21V3z" fill="none" stroke="currentColor" stroke-width="1.800" stroke-linejoin="round"/></svg>',
    tag: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.500 13.400 11 3.800a2 2 0 0 0-1.400-.6H4a2 2 0 0 0-2 2v5.600a2 2 0 0 0 .6 1.400l9.600 9.600a2 2 0 0 0 2.800 0l5.500-5.600a2 2 0 0 0 0-2.800z" fill="none" stroke="currentColor" stroke-width="1.800" stroke-linejoin="round"/><circle cx="7.500" cy="7.500" r="1.200" fill="currentColor"/></svg>'
  };
  function icon(name, cls) { var s = el('span', cls || 'hv-pst__ic'); s.setAttribute('aria-hidden', 'true'); s.innerHTML = ICONS[name]; return s; } /* fixed icon markup only, never customer text */
  var RINGS = 4;

  function post(r, i) {
    var n = rate(r), who = r.reviewer_name || 'Customer';
    var li = el('li', 'hv-pst');
    var head = el('div', 'hv-pst__head');
    var ring = el('span', 'hv-pst__ring hv-pst__ring--' + (i % RINGS)); ring.appendChild(el('span', 'hv-pst__av', who.trim().charAt(0).toUpperCase() || '#'));
    var nm = el('span', 'hv-pst__who'); nm.appendChild(el('b', '', who)); nm.appendChild(el('small', '', '\u2713 Verified buyer'));
    head.appendChild(ring); head.appendChild(nm); head.appendChild(el('span', 'hv-pst__dots', '\u2022\u2022\u2022')).setAttribute('aria-hidden', 'true');
    li.appendChild(head);

    var ph = el('button', 'hv-pst__photo'); ph.type = 'button'; ph.setAttribute('aria-label', 'Open the review by ' + who);
    var big = photo(r), img = document.createElement('img');
    img.src = setWidth(big, 600); img.srcset = setWidth(big, 400) + ' 400w, ' + setWidth(big, 600) + ' 600w, ' + setWidth(big, 900) + ' 900w'; img.sizes = '(min-width: 750px) 300px, 78vw';
    img.alt = 'Photo from ' + who; img.loading = 'lazy'; img.decoding = 'async'; ph.appendChild(img);
    ph.appendChild(icon('heart', 'hv-pst__pop'));
    ph.addEventListener('click', function () { openModal(i); });
    li.appendChild(ph);

    var acts = el('div', 'hv-pst__acts'); acts.setAttribute('aria-hidden', 'true');
    var left = el('span', 'hv-pst__actl'); left.appendChild(icon('heart', 'hv-pst__ic hv-pst__ic--like')); left.appendChild(icon('chat')); left.appendChild(icon('send'));
    acts.appendChild(left); acts.appendChild(icon('save'));
    li.appendChild(acts);

    var rt = el('div', 'hv-pst__rating'); rt.appendChild(stars(n, 'hv-pst__stars')); rt.appendChild(el('span', 'hv-pst__score', n + '.0'));
    li.appendChild(rt);

    var text = String(r.body || r.title || '').replace(/\s+/g, ' ').trim();
    var cap = el('p', 'hv-pst__cap'); cap.appendChild(el('b', '', who + ' ')); cap.appendChild(document.createTextNode(clip(text, 140)));
    if (text.length > 140) { var more = el('button', 'hv-pst__morebtn', 'more'); more.type = 'button'; more.addEventListener('click', function () { openModal(i); }); cap.appendChild(document.createTextNode(' ')); cap.appendChild(more); }
    li.appendChild(cap);

    if (r.product_title) { var tg = el('a', 'hv-pst__tag'); tg.href = r.product_url || '#'; tg.appendChild(icon('tag')); tg.appendChild(el('span', '', shortName(r.product_title))); li.appendChild(tg); }
    return li;
  }

  var posts = [], timer = null, paused = false, visible = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function step() { var a = posts[0], b = posts[1]; return a && b ? b.offsetLeft - a.offsetLeft : (a ? a.offsetWidth : 0); }
  function current() { var s = step(); return s ? Math.round(grid.scrollLeft / s) : 0; }
  function atEnd() { return grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4; }
  function go(dir, user) {
    var s = step(); if (!s) return;
    var left = dir > 0 ? (atEnd() ? 0 : (current() + 1) * s) : (grid.scrollLeft <= 4 ? grid.scrollWidth : (current() - 1) * s);
    grid.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
    if (user) restart();
  }
  function restart() {
    clearInterval(timer);
    var secs = Number(root.getAttribute('data-seconds')) || 0;
    if (!secs || reduce || posts.length < 2) return;
    timer = setInterval(function () { if (!paused && visible && !document.hidden && !(modal && !modal.m.hidden)) go(1, false); }, secs * 1000);
  }

  function build(rs) {
    data = rs.filter(function (r) { return photo(r); }).slice(0, Number(root.getAttribute('data-max')) || 8);
    if (!data.length) throw new Error('empty');
    var frag = document.createDocumentFragment();
    data.forEach(function (r, i) { var li = post(r, i); posts.push(li); frag.appendChild(li); });
    grid.textContent = ''; grid.appendChild(frag);
    root.classList.add('is-ready');
    (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(function () { ensureModal(); });
    var prev = root.querySelector('[data-pst-prev]'), next = root.querySelector('[data-pst-next]');
    if (prev) prev.addEventListener('click', function () { go(-1, true); });
    if (next) next.addEventListener('click', function () { go(1, true); });
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { grid.addEventListener(ev, function () { paused = true; }, { passive: true }); });
    grid.addEventListener('mouseleave', function () { paused = false; });
    grid.addEventListener('focusout', function () { paused = false; });
    grid.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 6000); }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.2 }).observe(grid);
    restart();
  }
  function giveUp() { var g = root.querySelector('[data-hv-rx]'); if (g) g.hidden = true; if (fail) fail.hidden = false; }

  function load() {
    if (started) return; started = true;
    var qs = 'reviews_selection=' + encodeURIComponent(root.getAttribute('data-selection') || 'featured_reviews') +
      '&carousel_type=cards&star_rating=all&custom_tags=&tag_filter=&max_reviews=12' +
      '&url=' + encodeURIComponent(root.getAttribute('data-site') || location.origin) +
      '&shop_domain=' + encodeURIComponent(root.getAttribute('data-shop') || '') +
      '&platform=shopify&primary_language=en&display_order=media_first&translation_locale=en';
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, 9000);
    fetch('https://cdn.judge.me/reviews/reviews_for_carousel?' + qs, { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('feed ' + r.status); return r.json(); })
      .then(function (d) { clearTimeout(t); build((d && d.reviews) || []); })
      .catch(function () { clearTimeout(t); giveUp(); });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '700px 0px' });
    io.observe(root);
  } else {
    (window.requestIdleCallback || function (f) { setTimeout(f, 2500); })(load);
  }
})();
